// @ts-nocheck
/* eslint-disable */
export const chevronUpIcon = {
    data: `<svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 12.5L9.5 5L17 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'chevron-up' as const
};